export default __webpack_public_path__ + "static/media/instagram-icon-blue.93406e0b.svg";